import { render } from "./MunicipioUf.vue?vue&type=template&id=236f4738&ts=true"
import script from "./MunicipioUf.vue?vue&type=script&lang=ts"
export * from "./MunicipioUf.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__